import { faGripVertical } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';

interface AutomationDragHandleProps {
  active?: boolean;
  disabled?: boolean;
  label: string;
}

export const AutomationDragHandle: FC<AutomationDragHandleProps> = ({
  active = false,
  disabled = false,
  label,
}) => {
  const borderColor = active ? 'primary.main' : 'neutral.6';

  return (
    <IconButton
      aria-label={label}
      disabled={disabled}
      size="small"
      sx={{
        bgcolor: active ? 'primary.lighter' : 'background.paper',
        borderColor,
        color: active ? 'primary.dark' : 'text.secondary',
        cursor: disabled ? 'not-allowed' : 'grab',
        flexShrink: 0,
        '&:hover': {
          borderColor,
        },
      }}
      variant="tertiary"
    >
      <Icon icon={faGripVertical} size="xsmall" />
    </IconButton>
  );
};
